import { render, staticRenderFns } from "./WNav.vue?vue&type=template&id=0769db0f&"
import script from "./WNav.vue?vue&type=script&lang=ts&"
export * from "./WNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports